module.exports = __webpack_public_path__ + "media/public/images/auth/icon-vkontakte-b45f57f93dbe820fbe0ac393ddd20d06.svg";